<!-- several images - gallery -->
<div
  *ngIf="images?.length > 1"
  appGallery
  imageIndex="0"
  [ngClass]="'detail-gallery ' + (classList | addClassList: { mainClass: 'detail-gallery--' })"
  [album]="images"
  [isHowItWorks]="isHowItWorks"
  [title]="title"
  [isOpenable]="showGalleryOnIconClick"
  [isRoomCategory]="true"
>
  <div class="guest-capacity__container" data-testid="qa-guest-capacity">
    <app-guest-capacity *ngIf="showMaxGuestsIcon" [maxGuests]="maxGuests" />
  </div>
  <span *ngIf="showGalleryOnIconClick" class="detail-gallery__image-icon">
    <i class="fa-regular fa-images"></i>
  </span>

  <swiper-container #itemSwiper appSwiper init="false" [config]="swiperConfig" [params]="params">
    <ng-container *ngFor="let image of images; let i = index">
      <swiper-slide *ngIf="i <= maxSlidesNum">
        <picture *ngIf="i <= maxSlidesNum">
          <!--Desktop-->
          <source
            media="(min-width: 1024px)"
            [attr.data-srcset]="image.url + '?w=268&h=217&fit=crop&auto=format&q=60'"
          />
          <!--Tablet devices-->
          <source
            media="(min-width: 768px)"
            [attr.data-srcset]="image.url + '?w=390&h=308&fit=crop&auto=format&q=60'"
          />
          <!--Mobile devices-->
          <img
            appImageFallback
            class="lazyload responsive-img detail-gallery__image"
            alt=""
            src="{{ imagePlaceholder + '?w=500&h=275&fit=crop&auto=format&q=60' }}"
            [id]="'qa_listings-property-img-' + image.position + '-0'"
            [attr.data-src]="image.url + '?w=500&h=275&fit=crop&auto=format&q=60'"
          />
        </picture>
      </swiper-slide>
    </ng-container>
  </swiper-container>
</div>

<!-- one image -->
<div
  *ngIf="images?.length <= 1"
  appGallery
  imageIndex="0"
  [ngClass]="'detail-gallery detail-gallery--single ' + (classList | addClassList: { mainClass: 'detail-gallery--' })"
  [album]="images"
  [title]="title"
  [isOpenable]="showGalleryOnIconClick"
  [isRoomCategory]="true"
>
  <i *ngIf="showGalleryOnIconClick" class="fas fa-images detail-gallery__image-icon"></i>
  <div
    class="detail-gallery__image-single"
    [ngClass]="{ 'flex items-center justify-center min-h-[180px] md:min-h-0': !images?.length }"
  >
    <img
      alt=""
      appImageFallback
      class="lazyload"
      [ngClass]="{ 'responsive-img detail-gallery__image': images?.length }"
      src="{{ imagePlaceholder + '?w=800&h=530&fit=crop&auto=format&q=60' }}"
      [attr.data-src]="images && images.length ? images[0]?.url + '?w=640&h=512&fit=crop&auto=format&q=60' : ''"
      [id]="'qa_listings-property-img-' + index + '-0'"
    />
  </div>
</div>
